/** Lookup.ParticipantRoles ids (backend ParticipantRoleEnum). */
export enum ParticipantRole {
	Plaintiff = 1,
	Defendant = 2,
	CommitteeSecretary = 3,
	CommitteeChairman = 4,
	FirstMember = 5,
	SecondMember = 6,
	PlaintiffAgent = 7,
	DefendantAgent = 8,
}
